import styled, { css } from 'styled-components';
import { rgba } from 'polished';

// Import styles
import { flex, customMinResponsive } from 'components/styles';

type WrapperProps = {
	isShort: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
	${flex({ fd: 'column', ai: 'flex-start' })}
	flex: 1;

	${customMinResponsive(
		1100,
		css<WrapperProps>`
			flex-basis: ${({ isShort }) => (isShort ? 30 : 50)}%;
		`
	)}
`;

export const Title = styled.h3<{ isSmallTitle: boolean }>`
	color: ${({ theme }) => theme.configurator.color.primary};
	font-weight: ${({ theme }) => theme.font.medium};
	font-size: 2rem;
	line-height: 1.3em;

	${({ isSmallTitle }) =>
		isSmallTitle &&
		css`
			font-size: 1.8rem;
		`}
`;

export const SubtitleWrapper = styled.div`
	${flex()}
	gap: 0.4em;
`;

export const Subtitle = styled.p`
	color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.7)};
	font-size: 1.4rem;
	line-height: 1.6em;
`;

export const Description = styled.div`
	color: ${({ theme }) => rgba(theme.configurator.color.primary, 0.6)};
	margin-top: 2rem;
	font-size: 1.5rem;
	line-height: 1.4em;
	font-weight: ${({ theme }) => theme.font.light};
`;
